import React from 'react';
import { DataGrid } from '../common/datagrid/ResponsiveDataGrid';
import CustomToolbar from '../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';
import { Paper } from '@mui/material';

const EmployeeList = ({
  apiRef,
  columns,
  employees,
  error,
  loading,
  handleRowEditStart,
  handleRowEditStop,
  handleCellFocusOut,
  columnVisibilityModel,
  onColumnVisibilityModelChange
}) => {
  const [pageSize, setPageSize] = React.useState(20);

  return (
    <Paper
      sx={{
        height: 700,
        width: '100%',
        p: 1,
      }}
    >
      <DataGrid
        apiRef={apiRef}
        rows={employees ? employees : []}
        columns={columns}
        components={{
          Toolbar: CustomToolbar,
          LoadingOverlay: CustomLoadingOverlay,
        }}
        componentsProps={{
          toolbar: { fileName: '사원리스트' },
        }}
        loading={loading}
        editMode="row"
        onRowEditStart={handleRowEditStart}
        onRowEditStop={handleRowEditStop}
        onCellFocusOut={handleCellFocusOut}
        initialState={{ pinnedColumns: { right: ['actions'] } }}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[5, 10, 20, 50, 100]}
        pagination
        columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
        onColumnVisibilityModelChange={onColumnVisibilityModelChange}
        
      />
    </Paper>
  );
};

export default EmployeeList;
